import React, { useState, useMemo } from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';

const GEO_URL = 'https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json';

const STATE_FIPS_TO_ABBR = {
  '01':'AL','02':'AK','04':'AZ','05':'AR','06':'CA','08':'CO','09':'CT',
  '10':'DE','11':'DC','12':'FL','13':'GA','15':'HI','16':'ID','17':'IL',
  '18':'IN','19':'IA','20':'KS','21':'KY','22':'LA','23':'ME','24':'MD',
  '25':'MA','26':'MI','27':'MN','28':'MS','29':'MO','30':'MT','31':'NE',
  '32':'NV','33':'NH','34':'NJ','35':'NM','36':'NY','37':'NC','38':'ND',
  '39':'OH','40':'OK','41':'OR','42':'PA','44':'RI','45':'SC','46':'SD',
  '47':'TN','48':'TX','49':'UT','50':'VT','51':'VA','53':'WA','54':'WV',
  '55':'WI','56':'WY','72':'PR',
};

function getColor(count, maxCount) {
  if (!count) return '#e5e7eb';
  const t = Math.min(count / Math.max(maxCount, 1), 1);
  const r = Math.round(15 + (1 - t) * 190);
  const g = Math.round(118 + (1 - t) * 130);
  const b = Math.round(110 + (1 - t) * 120);
  return `rgb(${r},${g},${b})`;
}

function UsHeatMap({ stateCounts }) {
  const [tooltip, setTooltip] = useState(null);

  const maxCount = useMemo(
    () => Math.max(...Object.values(stateCounts), 0),
    [stateCounts]
  );

  const total = useMemo(
    () => Object.values(stateCounts).reduce((a, b) => a + b, 0),
    [stateCounts]
  );

  if (total === 0) return null;

  return (
    <div className="us-heatmap" style={{ position: 'relative' }}>
      <ComposableMap
        projection="geoAlbersUsa"
        projectionConfig={{ scale: 1000 }}
        width={800}
        height={500}
        style={{ width: '100%', height: 'auto' }}
      >
        <Geographies geography={GEO_URL}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const fips = geo.id;
              const abbr = STATE_FIPS_TO_ABBR[fips] || '';
              const count = stateCounts[abbr] || 0;
              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill={getColor(count, maxCount)}
                  stroke="#fff"
                  strokeWidth={0.75}
                  style={{
                    default: { outline: 'none' },
                    hover: { outline: 'none', fill: count ? '#065f46' : '#d1d5db', cursor: count ? 'pointer' : 'default' },
                    pressed: { outline: 'none' },
                  }}
                  onMouseEnter={() => {
                    if (count > 0) setTooltip({ abbr, count });
                  }}
                  onMouseLeave={() => setTooltip(null)}
                />
              );
            })
          }
        </Geographies>
      </ComposableMap>
      {tooltip && (
        <div className="us-heatmap-tooltip">
          <strong>{tooltip.abbr}</strong>: {tooltip.count} freshling{tooltip.count !== 1 ? 's' : ''}
        </div>
      )}
      <div className="us-heatmap-legend">
        <span className="us-heatmap-legend-low">fewer</span>
        <div className="us-heatmap-legend-bar" />
        <span className="us-heatmap-legend-high">more</span>
      </div>
    </div>
  );
}

export default UsHeatMap;
